export default "__VITE_ASSET__CroHXoK7__"